<template>
  <v-container fluid class="pa-0">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <loading-overlay :isLoading="$store.state.services.isLoading" />
    <div class="ma-4">
      <ClientNav />
      <v-row dense>
        <v-col cols="12" lg="3" xl="2">
          <ClientSide />
        </v-col>
        <v-col cols="12" lg="9" xl="10">
          <v-row :class="defaultMargin">
            <v-card flat>
              <v-card-title class="text-display-4"
                >Service Plan - ADL</v-card-title
              >
              <v-card-text>
                <div class="text-body-2">
                  ADL’s that need to be completed today
                </div>
              </v-card-text>

              <v-card-subtitle class="error" v-if="page == 'Unsigned'">
                This list pulls unsigned ADL's in the past 3 days. Please search
                date ranges for any dates further than 3 days.
              </v-card-subtitle>
            </v-card>
          </v-row>
          <v-divider :class="defaultMargin"></v-divider>
          <v-row :class="defaultMargin">
            <v-btn-toggle>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="white"
                    @click="togglePage"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>
                      {{
                        page === "ADL"
                          ? "mdi-format-list-bulleted"
                          : "mdi-card-text-outline"
                      }}</v-icon
                    >
                  </v-btn>
                </template>
                <span>{{ page === "ADL" ? "ADL History" : "ADL Card" }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="white"
                    @click="toggleUnsignedPage('Unverified')"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-format-list-text</v-icon>
                  </v-btn>
                </template>
                <span>Unverified ADL</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="white"
                    @click="toggleUnsignedPage('Unsigned')"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-list-status</v-icon>
                  </v-btn>
                </template>
                <span>Unsigned ADL</span>
              </v-tooltip>
            </v-btn-toggle>
            <v-spacer></v-spacer>
            <v-btn
              color="#2b3990"
              dark
              v-if="isAdmin"
              @click="adlDialog = true"
            >
              <v-icon left>add</v-icon>
              Add ADL
            </v-btn>
            <v-dialog v-model="adlDialog" class="pa-2" max-width="100%">
              <v-card>
                <v-card-title class="primary white--text headline"
                  >Add ADL</v-card-title
                >
                <v-divider></v-divider>

                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12> </v-flex>
                    <v-flex xs12 sm6 class="pa-4">
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="newADLDate"
                            label="ADL Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            @change="checkDateString()"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="newADLDate"
                          no-title
                          scrollable
                          @change="checkDateString()"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 class="pa-4">
                      <v-select
                        label="Service"
                        :items="serviceItems"
                        item-text="ServiceItem"
                        item-value="_id"
                        v-model="newADLService"
                        return-object
                        @change="populateADLData()"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 class="pa-4" v-if="!showList">
                      <v-text-field
                        label="Time"
                        v-model="newADLTime"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 class="pa-4" v-if="showList">
                      <v-select
                        label="Select a start time for this ADL"
                        :items="newADLTimeList"
                        v-model="newADLTime"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 class="pa-4">
                      <v-text-field
                        label="Assistance"
                        v-model="newADLAssistance"
                        reaonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 class="pa-4">
                      <v-select
                        label="Exception"
                        v-model="newADLException"
                        :items="exception"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 class="pa-4">
                      <v-textarea
                        label="Notes"
                        outlined
                        v-model="newADLNotes"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="addADL()" class="white--text" color="#259647">
                    Save
                  </v-btn>
                  <v-btn text @click="closeADLDialog" color="blue darken-1">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

          <div :class="defaultMargin">
            <adl-card-item
              ref="adl"
              v-if="page === 'ADL'"
              :morningServices="morningServices"
              :afternoonServices="afternoonServices"
              :eveningServices="eveningServices"
              :prnServices="prnServices"
              :isAuditorRole="isAuditorRole"
              @getADL="getADLData"
            />

            <adl-history
              v-if="showPage && page !== 'Unverified'"
              @getADL="getADLData"
              :isPageHistory="isPageHistory"
              :page="page"
              :isAuditorRole="isAuditorRole"
            />

            <unverified-list
              v-if="page === 'Unverified'"
              :clientID="clientID"
              :staff="staff"
              :userSignatureTz="userSignatureTz"
              :isAuditorRole="isAuditorRole"
            />
          </div>
        </v-col>
      </v-row>

      <Foot />
    </div>
  </v-container>
</template>
<script>
/*eslint-disable */
import { v4 as uuidv4 } from "uuid";
import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import Foot from "../../components/Footer";
import axios from "axios";
import moment from "moment";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { setUserTz, tz, setUserSignatureTz } from "../../../utils/timezone";
import AdlHistory from "@/components/serviceplan/adl/AdlHistory";
import AdlCardItem from "@/components/serviceplan/adl/AdlCardItem";
import LoadingOverlay from "@/components/shared/LoadingOverlay";
import UnverifiedList from "@/components/serviceplan/adl/AdlUnverifiedList";

const MORNING = [
  "6:00am",
  "7:00am",
  "8:00am",
  "9:00am",
  "10:00am",
  "11:00am",
  "12:00am",
  "1:00am",
  "2:00am",
  "3:00am",
  "4:00am",
  "5:00am",
];

const AFTERNOON = ["12:00pm", "1:00pm", "2:00pm", "3:00pm", "4:00pm", "5:00pm"];

const EVENING = ["6:00pm", "7:00pm", "8:00pm", "9:00pm", "10:00pm", "11:00pm"];

const WEEKDAY = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const url = require("../../client_config/config").url;

export default {
  components: {
    ClientNav,
    ClientSide,
    Foot,
    AdlCardItem,
    AdlHistory,
    LoadingOverlay,
    UnverifiedList,
  },
  data: () => ({
    headers: [
      {
        text: "Date",
        align: "start",
        sortable: true,
        value: "Date",
      },
      { text: "Service", value: "ServiceName" },
      { text: "Time", value: "Time" },
      { text: "Assistance", value: "Assistance" },
      { text: "Exception", value: "Exception" },
      { text: "Notes", value: "Notes" },
      { text: "Signature", value: "Signature" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    unsignedHeaders: [
      {
        text: "date",
        align: "start",
        sortable: true,
        value: "Date",
      },
      { text: "Service Item", value: "ServiceItem" },
      { text: "Scheduled Time", value: "ScheduledTime" },
      // { text: "Days", value: "Days" },
      { text: "Instructions", value: "Instructions", width: "40%" },
    ],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    staff: localStorage.getItem("Name"),
    cardIndex: null,
    reveal: false,
    signaturepop: false,
    newEnergySignature: "",
    selectedSigned: [],
    dialog: false,
    show: false,
    search: "",
    page: "ADL",
    newDate: "",
    newTime: "",
    newAssistance: "",
    newException: "",
    newNotes: "",
    newSignature: "",
    newService: "",
    services: [],
    msg: false,
    color: "",
    text: "",
    assistance: [
      "Independent",
      "Minimal Assistance",
      "Moderate Assistance",
      "Total Assistance",
    ],
    exception: ["Refused", "ADL on Hold", "Absent", "Other"],
    //   adls: [
    //       { title: "Breakfast - AM", image: "https://images.unsplash.com/photo-1493770348161-369560ae357d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60", description: "What did the client eat for breakfast?  Remember to follow the menu and prepare nutritious food."},
    //       { title: "Hair - AM", image: "https://images.unsplash.com/photo-1527799820374-dcf8d9d4a388?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60", description: "Assist or prompt the client in proper grooming skills."},
    //       { title: "Oral - AM", image: "https://images.unsplash.com/photo-1588473659726-030f9bf6341d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60", description: "Assist or prompt the client in proper brushing teeth top/bottom, tongue and roof of mouth."},
    //       { title: "Shave - AM", image: "https://images.unsplash.com/photo-1559715544-33be62554de3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60", description: "Assist or prompt the client in properly shaving."},
    //   ],
    //   pms: [
    //       { title: "Lunch - PM", image: "https://images.unsplash.com/photo-1546793665-c74683f339c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60", description: "What did the client eat for breakfast?  Remember to follow the menu and prepare nutritious food."},
    //       { title: "Activitites - PM", image: "https://images.unsplash.com/photo-1584676173446-15419d1faab8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60", description: "Assist or prompt the client in proper grooming skills."},
    //   ],
    //   nights: [
    //       { title: "Dinner - Night", image: "https://images.unsplash.com/photo-1515516969-d4008cc6241a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60", description: "What did the client eat for breakfast?  Remember to follow the menu and prepare nutritious food."},
    //       { title: "Reading - Night", image: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60", description: "Assist or prompt the client in proper grooming skills."},
    //   ],
    //   prns: [
    //       { title: "Chores - PRN", image: "https://images.unsplash.com/photo-1563453392212-326f5e854473?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60", description: "What did the client eat for breakfast?  Remember to follow the menu and prepare nutritious food."},
    //       { title: "Laundry - PRN", image: "https://images.unsplash.com/photo-1582735689369-4fe89db7114c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60", description: "Assist or prompt the client in proper grooming skills."},
    //   ],
    adls: [],
    morningServices: [],
    afternoonServices: [],
    eveningServices: [],
    prnServices: [],
    imageItem: {
      "Activities, Attitude and Behavior":
        "https://images.unsplash.com/photo-1493311532826-91f3915a3c6e?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
      Ambulation:
        "https://image.freepik.com/free-photo/closeup-mid-section-man-with-crutches_13339-36661.jpg",
      "Bathing/Showering":
        "https://images.unsplash.com/photo-1599603780100-9a9e42b0489f?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1352&q=80",
      "Bed Making":
        "https://images.unsplash.com/photo-1557127275-f8b5ba93e24e?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
      "Behavioral Management":
        "https://images.unsplash.com/photo-1562876554-8ba1b66b7cb7?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=701&q=80",
      Breakfast:
        "https://images.unsplash.com/photo-1493770348161-369560ae357d?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
      "Cleaning Bedroom":
        "https://cdn8.dissolve.com/p/D929_63_556/D929_63_556_1200.jpg",
      Dinner:
        "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
      Dressing:
        "https://images.unsplash.com/photo-1567721571968-266680c30815?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1350&q=80",
      "Financial Management":
        "https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1353&q=80",
      Grooming:
        "https://images.unsplash.com/photo-1598887296391-0faf1eb670d1?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
      Hair: "https://images.unsplash.com/photo-1606333259737-6da197890fa2?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
      Housekeeping:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlGw8Za3Uw52vaKjMvsxozGdisTfZGrOHuCg&usqp=CAU",
      Laundry:
        "https://images.unsplash.com/photo-1582735689369-4fe89db7114c?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
      Lunch:
        "https://images.unsplash.com/photo-1565895405138-6c3a1555da6a?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1350&q=80",
      Mobility:
        "https://images.unsplash.com/photo-1563805898174-32757f44c556?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
      Oral: "https://images.unsplash.com/photo-1607613009820-a29f7bb81c04?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80",
      Reading:
        "https://images.unsplash.com/photo-1519682577862-22b62b24e493?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
      Shave:
        "https://images.unsplash.com/photo-1524230616393-d6229fcd2eff?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1350&q=80",
      Toileting:
        "https://images.unsplash.com/photo-1581094982559-6a5b36f02e0f?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80",
      "Education/Schooling":
        "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1350&q=80",
      "Physical Fitness":
        "https://images.unsplash.com/photo-1558611848-73f7eb4001a1?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1351&q=80",
      "Meal Plans":
        "https://plus.unsplash.com/premium_photo-1661777702966-aed29ab4106b?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },

    tempData: [],
    clientID: null,
    userId: localStorage.getItem("userId"),
    userName: localStorage.getItem("Name"),
    adlID: "",
    titleForm: "Update ADL Item",
    requiredRules: [],
    adlImage: "",
    editADL: false,
    isSaving: false,
    isAdmin: false,
    adlDialog: false,
    newADLDate: "",
    newADLService: null,
    newADLTime: "",
    newADLTimeList: [],
    newADLAssistance: "",
    newADLException: "",
    newADLNotes: "",
    menu: false,
    showList: false,
    editedIndex: -1,
    editedItem: {
      date: "",
      time: "",
      assistance: "",
      exception: "",
      notes: "",
      signature: "",
    },
    defaultItem: {
      date: "",
      time: "",
      assistance: "",
      exception: "",
      notes: "",
      signature: "",
    },
    selectedIndex: [],
    selectedADL: [],
    serviceItems: [],
    multipleSelectedItem: false,
    sampleData: "",
    isPageHistory: true,
  }),
  computed: {
    ...mapGetters(["getUserTimezone", "getDefaultTz"]),

    ...mapGetters({
      getUserTimezone: "timezones/getUserTimezone",
      getDefaultTz: "timezones/getDefaultTz",
      getADLs: "services/getADLs",
      getAllClientServices: "services/getAllClientServices",
    }),

    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },

    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },

    userSignatureTz() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserSignatureTz(data);
    },

    showPage() {
      return (
        this.page == "History" ||
        ("unsigned" && this.page != "ADL" && this.page != "unverified")
      );
    },

    defaultMargin() {
      return this.$vuetify.breakpoint.xsOnly ? "ma-0 my-3" : "ma-3";
    },

    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }

  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  async created() {
    this.clientID = this.$route.params.clientID;
    await this.fetchUser();
    this.getADLData();
    if (
      localStorage.getItem("userRole") == "Administration" ||
      localStorage.getItem("userRole") == "Human Resources" ||
      localStorage.getItem("userRole") == "Client Services Manager" ||
      localStorage.getItem("userRole") == "Compliance Manager" ||
      localStorage.getItem("userRole") == "Program Manager" ||
      localStorage.getItem("userRole") == "Medical Manager"
    ) {
      this.isAdmin = true;
    }
  },

  methods: {
    ...mapActions({
      fetchUser: "timezones/fetchUser",
      fetchADL: "services/fetchADL",
    }),

    checkDateString() {
      // Original date string
      var originalDateString = this.newADLDate;

      // Convert the original date string to a Date object
      var originalDate = new Date(originalDateString);

      // Add 1 hour to the original date
      originalDate.setHours(originalDate.getHours() + 1);

      // Convert the updated date back to a string in the format "YYYY-MM-DD"
      var updatedDateString = originalDate.toISOString().substr(0, 10);
    },

    ...mapMutations({
      setChat: "SET_CHAT",
      setLoading: "services/SET_LOADING",
      setDisableButton: "services/SET_DISABLE_BUTTON",
    }),

    closeADLDialog() {
      this.adlDialog = false;
    },

    populateADLData() {
      if (this.newADLService.ScheduledTime.length > 1) {
        this.showList = true;
        for (var i = 0; i < this.newADLService.ScheduledTime.length; i++) {
          this.newADLTimeList.push(this.newADLService.ScheduledTime[i]);
        }
      } else {
        this.showList = false;
        this.newADLTime = this.newADLService.ScheduledTime[0];
      }
      this.newADLAssistance = this.newADLService.LOA;
    },

    clearADLData() {
      this.newADLService = "";
      this.newADLDate = "";
      this.newADLTime = "";
      this.newADLAssistance = "";
      this.newADLNotes = "";
      this.newADLException = "";
    },

    addADL() {
      // Original date string
      var originalDateString = this.newADLDate;

      // Convert the original date string to a Date object
      var originalDate = new Date(originalDateString);

      // Add 1 hour to the original date
      originalDate.setHours(originalDate.getHours() + 12);

      // Convert the updated date back to a string in the format "YYYY-MM-DD"
      var updatedDateString = originalDate.toISOString();

      var req_body = {
        Service: this.newADLService,
        Date: updatedDateString,
        Time: this.newADLTime,
        Assistance: this.newADLAssistance,
        Exception: this.newADLException,
        Notes: this.newADLNotes,
        ClientID: this.clientID,
      };
      axios.post(`${url}/adl`, req_body).then((res) => {
        this.getADLData();
        if (res.status == 400) {
          res.json().then(function (data) {
            alert(data.msg);
          });
        }
        this.msg = true;
        this.text = "ADL added successfully";
      });

      this.closeADLDialog();
      // this.clearADLData()
    },

    initialize() {
      this.adls = [];
    },
    validate() {
      return this.$refs.form.validate();
    },

    getADLData() {
      this.setLoading(true);
      const data = {
        id: this.clientID,
        userTimezone: this.userTimezone,
      };
      this.fetchADL(data).then(() => {
        this.getServicePlan();
        console.log("fetching adls.............123");
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async getServicePlan() {
      await axios
        .get(`${url}/servicePlans/status/${this.clientID}`)
        .then(async (res) => {
          this.serviceItems = res.data.services;
          this.morningServices = [];
          this.afternoonServices = [];
          this.eveningServices = [];
          this.prnServices = [];
          this.tempData = res.data.services;

          //parse local date base on user timezone
          // let tzdate = tz(new Date(), this.userTimezone).format("MM-DD-YYYY");
          let tzdate = tz(new Date(), this.userTimezone);

          for (var i = 0; i < this.tempData.length; i++) {
            if (
              this.tempData[i].Days.includes(WEEKDAY[new Date(tzdate).getDay()])
            ) {
              // Custom service attributes to prevent duplicate input fields
              this.tempData[i].newAssistance = "";
              this.tempData[i].newException = "";
              this.tempData[i].newNotes = "";
              this.tempData[i].newSignature = "";
              this.tempData[i].error = "";
              this.tempData[i].bpError = "";
              this.tempData[i].BloodPressure = "";

              for (const [key, value] of Object.entries(this.imageItem)) {
                if (this.tempData[i].ServiceItem == key) {
                  this.tempData[i].ImageUrl = value;
                }
              }

              //Initalized AdminTime value to PRN if AdminTime is Empty
              let scheduleTime =
                this.tempData[i].ScheduledTime.length != 0
                  ? this.tempData[i].ScheduledTime
                  : ["PRN"];
              // Check all available Scheduled Time

              scheduleTime.forEach((time) => {
                // Check if Morning, Afternoon, or Evening, or PRN for default/no time
                this.tempData[i].newScheduledTime = time;
                this.tempData[i].isSigned = this.isSigned(this.tempData[i]);
                let tempCard = Object.assign({}, this.tempData[i]);

                // Do not add this ADL if the current weekday is not on the specified "Days"
                if (MORNING.includes(time)) {
                  this.morningServices.push({
                    ...tempCard,
                    scheduleTime: time,
                    generatedId: uuidv4(),
                    reveal: true,
                    Type: "Morning", //Override Type (Time to be completed) since we already loop schedule time
                  });
                } else if (AFTERNOON.includes(time)) {
                  this.afternoonServices.push({
                    ...tempCard,
                    scheduleTime: time,
                    generatedId: uuidv4(),
                    reveal: true,
                    Type: "Afternoon", //Override Type (Time to be completed) since we already loop schedule time
                  });
                } else if (EVENING.includes(time)) {
                  this.eveningServices.push({
                    ...tempCard,
                    scheduleTime: time,
                    generatedId: uuidv4(),
                    reveal: true,
                    Type: "Night", //Override Type (Time to be completed) since we already loop schedule time
                  });
                } else {
                  this.prnServices.push({
                    ...tempCard,
                    scheduleTime: time,
                    generatedId: uuidv4(),
                    reveal: true,
                  });
                }
              });
            }
          }

          if (res.data.mealPlans) {
            res.data.mealPlans.forEach((mealPlan) => {
              mealPlan.MealPlans.forEach((meal) => {
                let mealDate = moment(meal.date, "dddd, MM-DD-YYYY").format(
                  "dddd, MM-DD-YYYY"
                );
                let tzdate = tz(new Date(), this.userTimezone).format(
                  "dddd, MM-DD-YYYY"
                );

                if (mealDate === tzdate) {
                  let mealCard = {
                    ...mealPlan,
                    Description: meal.instructions,
                    ServiceItem: "Meal Plan",
                    ImageUrl: this.imageItem["Meal Plans"],
                    newAssistance: "",
                    newException: "",
                    newNotes: "",
                    newSignature: "",
                    error: "",
                    bpError: "",
                    BloodPressure: "",
                    scheduleTime: "",
                    isSigned: false,
                    generatedId: uuidv4(),
                    reveal: true,
                    ClientID: this.clientID,
                    Service: mealPlan._id,
                    isSigned: this.isSigned(mealPlan),
                  };

                  const addMealService = (
                    timeCategory,
                    { time, notes },
                    type
                  ) => {
                    if (timeCategory.includes(time)) {
                      this[`${type.toLowerCase()}Services`].push({
                        ...mealCard,
                        Type: type,
                        newScheduledTime: time,
                        newNotes: notes,
                        isSigned: this.isSigned({
                          ...mealCard,
                          Type: type,
                          newScheduledTime: time,
                        }),
                      });
                    }
                  };

                  addMealService(
                    MORNING,
                    { time: meal.breakfast.time, notes: meal.breakfast.notes },
                    "Morning"
                  );
                  addMealService(
                    AFTERNOON,
                    { time: meal.lunch.time, notes: meal.lunch.notes },
                    "Afternoon"
                  );
                  addMealService(
                    EVENING,
                    { time: meal.dinner.time, notes: meal.dinner.notes },
                    "Evening"
                  );
                }
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.setLoading(false);
          this.setDisableButton(false);
        });
    },

    isSigned: function(service) {
      //parse local date base on user timezone
      let tzdate = tz(new Date(), this.userTimezone);
      let result = false;
      this.getADLs
        .filter(
          (item) =>
            item.Service._id == service._id &&
            item.Time === service.newScheduledTime &&
            tz(item.Date, this.userTimezone).isSame(moment(Date.now()), "day")
          // moment(new Date(item.Date)).isSame(new Date(tzdate), "day")
        )
        .forEach((adl) => {
          // Condition for DAILY ADL:
          // 1. If the current Service exists in the ADL History list
          // 2. If the date of the matching ADL History item happened TODAY
          // 3. If the Time is PRN or BLANK, then time of the day wouldn't matter as long as the date is TODAY
          // 4. OR if the time category of the ADL History matches with the Service's time category, then it means it's administered already.
          if (
            adl.Time == "PRN" ||
            adl.Time == "" ||
            (MORNING.includes(adl.Time) &&
              MORNING.includes(service.newScheduledTime)) ||
            (AFTERNOON.includes(adl.Time) &&
              AFTERNOON.includes(service.newScheduledTime)) ||
            (EVENING.includes(adl.Time) &&
              EVENING.includes(service.newScheduledTime))
          ) {
            result = true;
          }
        });
      return result;
    },

    // async addAttendance() {
    //   try {
    //     var req_body = {
    //       Code: "SC-001",
    //       Date: new Date(),
    //       Signature: this.userName + " - " + this.userSignatureTz,
    //       ClientID: this.clientID,
    //       Units: 1,
    //       ServiceUnit: "Daily",
    //     };
    //     await axios.post(`${url}/attendance`, req_body).then((res) => {
    //       if (res.status == 200) {
    //         console.log("attendance added");
    //       }
    //     });
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    readMore(index) {
      this.cardIndex = index;
      this.reveal = true;
    },

    selectedItem(data) {
      let index = this.selectedIndex[data.generatedId];

      if (index === undefined) {
        index = this.selectedADL.length;
        this.selectedIndex[data.generatedId] = index;
      }

      this.selectedADL[index] = data;

      this.selectedADL.filter((item) => item.active === true).length >= 2
        ? (this.multipleSelectedItem = true)
        : (this.multipleSelectedItem = false);

      this.setChat(!this.multipleSelectedItem);
    },

    onAddItem(item) {
      this.$refs.adl.addADL(item);
    },

    addSignature(med) {
      if (this.signed) {
        this.newSignature = this.staff + " - " + this.userSignatureTz;
      } else {
        this.newSignature = "";
      }

      if (med.signed) {
        med.newSignature = this.staff + " - " + this.userSignatureTz;
      } else {
        med.newSignature = "";
      }
      // Problem: Signature ALL text field disappears after submit
      //  Solution: Reset the checkbox and the .signed attribute
    },

    togglePage() {
      if (this.page === "ADL") {
        this.page = "History";
      } else if (this.page === "History") {
        this.isPageHistory = true
        this.page = "ADL";
      } else {
        this.isPageHistory = true
        this.page = "ADL";
      }
    },
    toggleUnsignedPage(page) {
      this.page = page;
      this.isPageHistory = false
    },
  },
};
</script>
<style scoped>
.v-select label {
  font-size: 0.8em;
}
/* #clientSide {
        display: none;
    } */
.test {
  margin: 50px;
}
#center {
  margin-left: 70px;
}

@media only screen and (max-width: 480px) {
  #image {
    height: 250px;
  }

  #ADLCard {
    width: 320px;
  }
}
.v-card--reveal {
  bottom: 0;
  top: 0;
  position: absolute;
  width: 100%;
  background-color: #fff !important;
  z-index: 9999;
}
</style>
